/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForTagDiscovery extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForTagDiscovery");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForTagDiscovery.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForTagDiscovery>): BackgroundJobPayloadForTagDiscovery {
        let obj = Object.assign(new BackgroundJobPayloadForTagDiscovery(), model);
        BackgroundJobPayloadForTagDiscovery.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForTagDiscovery>): BackgroundJobPayloadForTagDiscovery {
        if (!model) return null;
        return BackgroundJobPayloadForTagDiscovery.newInstance(<BackgroundJobPayloadForTagDiscovery> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForTagDiscovery) {
        if (!obj) return;

        models.BackgroundJobPayloadForTagDiscovery.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForTagDiscovery): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForTagDiscovery.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resources) {
            for (let val of this.resources) {
                models.TagDiscoveryResourceMapping.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account Id
     */
    service_account_id: string;

    /**
     * Location Id
     */
    location_id: string;

    resources: Array<models.TagDiscoveryResourceMapping>;

}
